import { useEffect } from "react";
import { Carousel } from "react-bootstrap";
import Aos from "aos";
const BankvoleHero = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <section className="bv-hero">
      <div className="bv-hero-inner">
        <div className="bv-hero-left" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
          <span className="bv-badge-pill">SECURE • SMART • REWARDING</span>
          <h1 className="bv-hero-title">
            A smarter way to manage and grow your wealth.
          </h1>
          <p className="bv-hero-text">
            Bankvole helps you securely organize your finances, grow your
            money, and achieve your short-term and long-term financial goals.
          </p>

          <p className="bv-hero-get">Get Bankvole (Available on iOS and Android)</p>
          <div className="bv-store-buttons">
            <a href="https://apps.apple.com/ng/app/bankvole/id6478485232"
              target="_blank"
              rel="noreferrer"
              className="bv-store-btn"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/app-store-badge.png`}
                alt="Download on the App Store"
              />
            </a>

            <a href="https://play.google.com/store/apps/details?id=com.bankvole.app"
              target="_blank"
              rel="noreferrer"
              className="bv-store-btn"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/icons/google-play-badge.png`}
                alt="Get it on Google Play"
              />
            </a>
          </div>
        </div>

        <div className="bv-hero-right" data-aos="flip-left" data-aos-duration="1500" data-aos-delay="300" data-aos-easing="ease-out-cubic">
          <Carousel fade controls={false} indicators={false} interval={3500}>
            <Carousel.Item>
              <img
                className="bv-hero-image"
                src={`${process.env.PUBLIC_URL}/assets/img/bankvole-hero-phone.png`}
                alt="Bankvole wallet screen"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="bv-hero-image"
                src={`${process.env.PUBLIC_URL}/assets/img/bankvole-hero-phone-2.png`}
                alt="Bankvole savings screen"
              />
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default BankvoleHero;